import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { LogoStrip } from '@/components/LogoStrip';
import { MobileStickyCta } from '@/components/MobileStickyCta';
import { SeoJsonLd } from '@/components/SeoJsonLd';
import { useHashScrollOnLoad } from '@/hooks/useHashScrollOnLoad';
import { useScrollDepth } from '@/hooks/useScrollDepth';
import { useSectionViews } from '@/hooks/useSectionViews';
import { MobileHero } from '@/sections/MobileHero';
import { PainPoints } from '@/sections/PainPoints';
import { Pricing } from '@/sections/Pricing';
import { Testimonials } from '@/sections/Testimonials';
import './MobileLandingPage.css';

/** Vista reducida de la landing; demo vía sticky CTA a WhatsApp (sin FAB flotante). */
export function MobileLandingPage() {
  useScrollDepth();
  useSectionViews();
  useHashScrollOnLoad();

  return (
    <div className="landing-entry landing-entry--mobile">
      <SeoJsonLd />
      <Header compact />
      <MobileHero />
      <LogoStrip />

      <main>
        <div className="mesh-bg-entry" aria-hidden />
        <PainPoints hideCta />
        <Testimonials />
        <Pricing />
      </main>

      <Footer />
      <MobileStickyCta />
    </div>
  );
}
